<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeMaterielFormat.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit" @click="checkPermissions(pemsMaterielFormat.maj)
          ? addEditMaterielFormat(null) : showPopUp()"
               :class="{'button-access-no-permission' :
               !checkPermissions(pemsMaterielFormat.maj) }">
              {{ $t('listeMaterielFormat.actions.add')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="setFilter(filterInput)" class="column is-12">
            <b-input :placeholder="$t('listeMaterielFormat.actions.search')"
                     type="search" icon="magnify"
                     v-model="filterInput">
            </b-input>
          </form>
        </div>
      </div>
    </div>
    <v-client-table :data=listeMaterielFormatFilter :columns="columns" :options="options"
                    ref="tableMaterielFormat">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableMaterielFormat.setLimit($event)"/>
      </template>

      <div slot="edit" slot-scope="props">
        <div @click="checkPermissions(pemsMaterielFormat.supprimer) ?
        addEditMaterielFormat(props.row) : showPopUp()" class="is-cursor-pointer">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(pemsMaterielFormat.maj) }"></b-icon>
        </div>
      </div>
      <div slot="archiver" slot-scope="props">
        <btn-action-icon
          :tooltip-label="$t(`general.button.${props.row.actif ? 'archiver' : 'desarchiver'}`)"
          :permission="pemsMaterielFormat.supprimer"
          @is-click="openPopUpArchivage(props.row)"
          icon-type="is-default"
          :icon="props.row.actif ? 'archive' : 'archive-arrow-up'">
        </btn-action-icon>
      </div>
      <div slot="delete" slot-scope="props">
        <btn-action-icon
          :tooltip-label="$t('general.button.delete')"
          :permission="pemsMaterielFormat.supprimer"
          @is-click="openPopUpSuppression(props.row.id)"
          icon-type="is-danger"
          icon="delete-forever">
        </btn-action-icon>
      </div>
    </v-client-table>
    <b-modal v-model="popUpAddEditMaterielFormat" has-modal-card class="modal">
      <pop-up-add-edit-materiel-format :materielFormat="selectedMaterielFormat"
                                      @reloadMaterielFormat="loadMaterielFormat()"/>
    </b-modal>
    <b-modal
      v-model="openPopUpDelete"
      has-modal-card
      class="modal"
      @close="closePopUp">
      <popUpPrevention
        :messHeader="$t('listeMaterielFormat.suppression.supprimer')"
        :messFooter="$t('general.suppression.sousTitre')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :messagesPopup="messages"
        :isErrorPopup="isError"
        @update:isError="messages = []"
        @yes="deleteFormat"
        @no="closePopUp"
      />
    </b-modal>
    <b-modal
      v-model="openPopUpArchiver"
      has-modal-card
      class="modal"
      @close="openPopUpArchiver = false">
      <popUpPrevention
        v-if="elementsToArchive.length > 0"
        :messHeader="$t(`listeMaterielFormat.archivage.${
            elementsToArchive[0].actif ? 'archiver' : 'desarchiver'
          }`)"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :messagesPopup="messages"
        :isErrorPopup="isError"
        @update:isError="messages = []"
        @yes="archiverFormat"
        @no="openPopUpArchiver = false"
      />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { archiver, remove } from '@/api/materielFormat/index';
import messageErreur from '@/services/general/messageErreur';
import { MATERIEL_FORMAT } from '@/configuration/gabed/permissionsGabedConf';
import breadcrumb from '@/components/general/breadcrumb';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import genererMaterielFormat from '@/services/parametrage/generation/genererMaterielFormat';
import popUpAddEditMaterielFormat from '@/components/parametrage/materielFormat/p_addEditMaterielFormat';
import TableItemsInView from '@/components/general/TableItemsInView';
import { SET_FILTER } from '@/store/modules/materielFormat-mutation-type';
import popUpPrevention from '@/components/general/popUpPrevention';
import btnActionIcon from '@/components/general/btnActionIcon';
import messageSuccess from '@/services/general/messageSucces';
import validation from '@/services/parametrage/validation/validationParametreGenerique';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Permissions = createNamespacedHelpers('permissions');
const MaterielFormat = createNamespacedHelpers('materielFormat');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      filterInput: '',
      pemsMaterielFormat: MATERIEL_FORMAT,
      popUpAddEditMaterielFormat: false,
      selectedMaterielFormat: {},
      openPopUpDelete: false,
      idToDelete: null,
      openPopUpArchiver: false,
      elementsToArchive: [],
      isError: false,
      messages: [],
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    popUpAddEditMaterielFormat,
    TableItemsInView,
    popUpPrevention,
    btnActionIcon,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('listeMaterielFormat.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeMaterielFormat.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeMaterielFormat.breadcrumb.liste'), route: { name: '' }, isActive: true },
      ];
    },
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...MaterielFormat.mapGetters({
      listeMaterielFormat: 'items',
      filter: 'filter',
    }),
    listeMaterielFormatFilter() {
      return this.listeMaterielFormat.filter(item => {
        return item.libelle.toLowerCase().includes(this.filter.toLocaleLowerCase()
          || this.filter);
      });
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeMaterielFormat.tab.libelle'),
          'surface.surfaceCommerciale': this.$t('listeMaterielFormat.tab.surfaceCommercial'),
          'surface.surfaceTlpe': this.$t('listeMaterielFormat.tab.surfaceTlpe'),
          edit: '',
          delete: '',
          archiver: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          archiver: 'colonneSelected',
        },
        sortable: ['libelle', 'surface.surfaceTlpe', 'surface.surfaceCommerciale'],
      };
    },
    columns() {
      return ['libelle', 'surface.surfaceCommerciale', 'surface.surfaceTlpe', 'edit', 'archiver', 'delete'];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...MaterielFormat.mapActions({
      actionsloadMaterielFormat: 'loadMaterielFormat',
    }),
    ...MaterielFormat.mapMutations({
      setFilter: SET_FILTER,
    }),
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
    }),
    addEditMaterielFormat(materielFormat) {
      if (!materielFormat) this.selectedMaterielFormat = genererMaterielFormat();
      else this.selectedMaterielFormat = cloneDeep(materielFormat);
      this.popUpAddEditMaterielFormat = true;
    },
    async loadMaterielFormat() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.actionsloadMaterielFormat();
        await this.loadParametreForce(PARAMETRES_KEYS.materielFormat);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    openPopUpSuppression(id) {
      this.idToDelete = id;
      this.isError = false;
      this.openPopUpDelete = true;
    },
    openPopUpArchivage(ligne) {
      this.isError = false;
      this.messages = [];
      this.elementsToArchive = [ligne];
      this.openPopUpArchiver = true;
    },
    async archiverFormat() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.elementsToArchive.length === 0) return;
        this.isError = false;
        this.messages = [];
        const payload = {
          archiver: this.elementsToArchive[0].actif,
          ids: this.elementsToArchive.map(e => e.id),
        };
        await archiver(payload);
        this.openPopUpArchiver = false;
        messageSuccess(this.$t(`listeMaterielFormat.archivage.${payload.archiver ? 'successArchiver' : 'successDesarchiver'}`));
        this.loadMaterielFormat();
        await this.loadParametreForce(PARAMETRES_KEYS.materielFormat);
      } catch (e) {
        messageErreur(this.$i18n);
      } finally {
        loadingComponent.close();
      }
    },
    async deleteFormat() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.isError = false;
        this.messages = [];
        await remove(this.idToDelete);
        this.closePopUp();
        messageSuccess(this.$t('listeMaterielFormat.suppression.successSupprimer'));
        await this.loadMaterielFormat();
        await this.loadParametreForce(PARAMETRES_KEYS.materielFormat);
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validation(e.response, this.messages);
          this.isError = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    closePopUp() {
      this.messages = [];
      this.openPopUpDelete = false;
    },
  },
  async mounted() {
    this.filterInput = this.filter;
    this.setInformationPage(this.$t('pageParametrage.formatMateriel.liste'));
    await this.loadMaterielFormat();
  },
};

</script>
